/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIModelsPuzzelAgents,
  RightioWBSAPIModelsPuzzelCallEvents,
  RightioWBSAPIModelsPuzzelCallerTypes,
  RightioWBSAPIModelsPuzzelEvents,
  RightioWBSAPIModelsPuzzelEventsCallInput,
  RightioWBSAPIModelsPuzzelEventsHistoryInput,
  RightioWBSAPIModelsPuzzelEventsInput,
  RightioWBSAPIModelsPuzzelPhoneNumbers,
  RightioWBSAPIModelsPuzzelPhoneNumbersInput,
  RightioWBSAPIModelsPuzzelUsers
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';
import type { BodyType } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves all Puzzel contact center agents including their group assignments, contact details, and special roles. Returns both active and inactive agents.
 * @summary Get all Agents
 */
export const puzzelAgentsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelAgents[]>(
      {url: `/api/Agents`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific Puzzel contact center agent by their unique identifier. Returns complete agent profile including group assignments and special roles.
 * @summary Get Agents by id
 */
export const puzzelAgentsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelAgents>(
      {url: `/api/Agents/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all caller type configurations including routing queues and screen pop URLs for CRM integration.
 * @summary Get all CallerTypes
 */
export const puzzelCallerTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelCallerTypes[]>(
      {url: `/api/CallerTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new caller type configuration for call routing and CRM integration. The ID must be unique.
 * @summary Create CallerTypes
 */
export const puzzelCallerTypesCreate = (
    rightioWBSAPIModelsPuzzelCallerTypes: BodyType<RightioWBSAPIModelsPuzzelCallerTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelCallerTypes>(
      {url: `/api/CallerTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelCallerTypes
    },
      options);
    }
  /**
 * Retrieves a specific caller type configuration by its unique identifier.
 * @summary Get CallerTypes by id
 */
export const puzzelCallerTypesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelCallerTypes>(
      {url: `/api/CallerTypes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing caller type configuration including routing queue and screen pop URL. Changes affect live call routing immediately.
 * @summary Update CallerTypes
 */
export const puzzelCallerTypesUpdate = (
    id: number,
    rightioWBSAPIModelsPuzzelCallerTypes: BodyType<RightioWBSAPIModelsPuzzelCallerTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallerTypes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelCallerTypes
    },
      options);
    }
  /**
 * Permanently deletes a caller type configuration. WARNING: This affects active call routing and cannot be undone.
 * @summary Delete CallerTypes
 */
export const puzzelCallerTypesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallerTypes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all call event records from Puzzel including queue events, agent interactions, and IVR selections. May return large datasets.
 * @summary Get all CallEvents
 */
export const puzzelCallEventsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelCallEvents[]>(
      {url: `/api/CallEvents`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves call event records filtered by source phone number or identifier. Useful for tracking customer interaction history or agent activity.
 * @summary Get CallEvents by source
 */
export const puzzelCallEventsGetBySource = (
    source: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelCallEvents[]>(
      {url: `/api/CallEvents/${source}`, method: 'GET'
    },
      options);
    }
  /**
 * Permanently deletes a call event record. Use with caution as this may affect compliance, reporting, and analytics. Consider archiving instead.
 * @summary Delete CallEvents by id
 */
export const puzzelCallEventsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallEvents/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all Puzzel system events that trigger integrations and workflows. May return large datasets.
 * @summary Get all Events
 */
export const puzzelEventsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelEvents[]>(
      {url: `/api/Events`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new Puzzel event record. Typically called by webhooks or real-time integrations to trigger workflows.
 * @summary Create Events
 */
export const puzzelEventsCreate = (
    rightioWBSAPIModelsPuzzelEvents: BodyType<RightioWBSAPIModelsPuzzelEvents>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelEvents>(
      {url: `/api/Events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelEvents
    },
      options);
    }
  /**
 * Retrieves a specific Puzzel system event by its unique identifier.
 * @summary Get Events by id
 */
export const puzzelEventsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelEvents>(
      {url: `/api/Events/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing Puzzel event record. Typically used for adding account codes or correcting integration data.
 * @summary Update Events
 */
export const puzzelEventsUpdate = (
    id: number,
    rightioWBSAPIModelsPuzzelEvents: BodyType<RightioWBSAPIModelsPuzzelEvents>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Events/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelEvents
    },
      options);
    }
  /**
 * Permanently deletes a Puzzel event record. Use with caution as events are important for audit trails and analytics.
 * @summary Delete Events
 */
export const puzzelEventsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Events/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all events for a specific Puzzel session, ordered by newest first. Useful for tracking complete call journeys.
 * @summary Get Events by sessionId
 */
export const puzzelEventsGetBySessionId = (
    rightioWBSAPIModelsPuzzelEventsInput: BodyType<RightioWBSAPIModelsPuzzelEventsInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelEvents[]>(
      {url: `/api/Events/sessionId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelEventsInput
    },
      options);
    }
  /**
 * Retrieves all events for a specific Puzzel call, ordered by newest first. Useful for tracking complete call journeys.
 * @summary Get Events by callId
 */
export const puzzelEventsGetByCallId = (
    rightioWBSAPIModelsPuzzelEventsCallInput: BodyType<RightioWBSAPIModelsPuzzelEventsCallInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelEvents[]>(
      {url: `/api/Events/callId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelEventsCallInput
    },
      options);
    }
  /**
 * Retrieves complete event history for a specific caller/source, ordered by newest first. Essential for customer context.
 * @summary Get Events by source
 */
export const puzzelEventsGetBySource = (
    rightioWBSAPIModelsPuzzelEventsHistoryInput: BodyType<RightioWBSAPIModelsPuzzelEventsHistoryInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelEvents[]>(
      {url: `/api/Events/source`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelEventsHistoryInput
    },
      options);
    }
  /**
 * Retrieves all configured phone numbers with their routing rules, priorities, and classifications for comprehensive number management.
 * @summary Get all PhoneNumbers
 */
export const puzzelPhoneNumbersGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelPhoneNumbers[]>(
      {url: `/api/PhoneNumbers`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new phone number configuration for call routing. The number becomes active immediately.
 * @summary Create PhoneNumbers
 */
export const puzzelPhoneNumbersCreate = (
    rightioWBSAPIModelsPuzzelPhoneNumbers: BodyType<RightioWBSAPIModelsPuzzelPhoneNumbers>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelPhoneNumbers>(
      {url: `/api/PhoneNumbers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelPhoneNumbers
    },
      options);
    }
  /**
 * Retrieves a specific phone number configuration by its phone number identifier.
 * @summary Get PhoneNumbers by id
 */
export const puzzelPhoneNumbersGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelPhoneNumbers>(
      {url: `/api/PhoneNumbers/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing phone number's routing configuration, priority, and classification. Changes take effect for new calls immediately.
 * @summary Update PhoneNumbers
 */
export const puzzelPhoneNumbersUpdate = (
    id: string,
    rightioWBSAPIModelsPuzzelPhoneNumbers: BodyType<RightioWBSAPIModelsPuzzelPhoneNumbers>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/PhoneNumbers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelPhoneNumbers
    },
      options);
    }
  /**
 * Permanently deletes a phone number configuration. Number becomes unroutable immediately. Consider routing to closed queue instead.
 * @summary Delete PhoneNumbers
 */
export const puzzelPhoneNumbersDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/PhoneNumbers/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Searches for a phone number configuration using POST body. Useful for secure lookups and integration scenarios.
 * @summary Get PhoneNumbers by number
 */
export const puzzelPhoneNumbersGetByNumber = (
    rightioWBSAPIModelsPuzzelPhoneNumbersInput: BodyType<RightioWBSAPIModelsPuzzelPhoneNumbersInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelPhoneNumbers>(
      {url: `/api/PhoneNumbers/phoneNumber`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelPhoneNumbersInput
    },
      options);
    }
  /**
 * Retrieves all Puzzel agent to booking system user mappings for integration management.
 * @summary Get all Users
 */
export const puzzelUsersGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelUsers[]>(
      {url: `/api/PuzzelUsers`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new Puzzel agent to booking system user mapping. Required for agent access to booking functionality.
 * @summary Create Users
 */
export const puzzelUsersCreate = (
    rightioWBSAPIModelsPuzzelUsers: BodyType<RightioWBSAPIModelsPuzzelUsers>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelUsers>(
      {url: `/api/PuzzelUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelUsers
    },
      options);
    }
  /**
 * Retrieves a specific Puzzel agent to user mapping by agent ID.
 * @summary Get Users by id
 */
export const puzzelUsersGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPuzzelUsers>(
      {url: `/api/PuzzelUsers/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing Puzzel agent to user mapping. Changes take effect on next agent login.
 * @summary Update Users
 */
export const puzzelUsersUpdate = (
    id: number,
    rightioWBSAPIModelsPuzzelUsers: BodyType<RightioWBSAPIModelsPuzzelUsers>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/PuzzelUsers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPuzzelUsers
    },
      options);
    }
  /**
 * Permanently deletes a Puzzel agent to user mapping. Agent loses booking system access immediately.
 * @summary Delete Users
 */
export const puzzelUsersDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/PuzzelUsers/${id}`, method: 'DELETE'
    },
      options);
    }
  export type PuzzelAgentsGetAllResult = NonNullable<Awaited<ReturnType<typeof puzzelAgentsGetAll>>>
export type PuzzelAgentsGetByIdResult = NonNullable<Awaited<ReturnType<typeof puzzelAgentsGetById>>>
export type PuzzelCallerTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof puzzelCallerTypesGetAll>>>
export type PuzzelCallerTypesCreateResult = NonNullable<Awaited<ReturnType<typeof puzzelCallerTypesCreate>>>
export type PuzzelCallerTypesGetByIdResult = NonNullable<Awaited<ReturnType<typeof puzzelCallerTypesGetById>>>
export type PuzzelCallerTypesUpdateResult = NonNullable<Awaited<ReturnType<typeof puzzelCallerTypesUpdate>>>
export type PuzzelCallerTypesDeleteResult = NonNullable<Awaited<ReturnType<typeof puzzelCallerTypesDelete>>>
export type PuzzelCallEventsGetAllResult = NonNullable<Awaited<ReturnType<typeof puzzelCallEventsGetAll>>>
export type PuzzelCallEventsGetBySourceResult = NonNullable<Awaited<ReturnType<typeof puzzelCallEventsGetBySource>>>
export type PuzzelCallEventsDeleteResult = NonNullable<Awaited<ReturnType<typeof puzzelCallEventsDelete>>>
export type PuzzelEventsGetAllResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsGetAll>>>
export type PuzzelEventsCreateResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsCreate>>>
export type PuzzelEventsGetByIdResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsGetById>>>
export type PuzzelEventsUpdateResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsUpdate>>>
export type PuzzelEventsDeleteResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsDelete>>>
export type PuzzelEventsGetBySessionIdResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsGetBySessionId>>>
export type PuzzelEventsGetByCallIdResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsGetByCallId>>>
export type PuzzelEventsGetBySourceResult = NonNullable<Awaited<ReturnType<typeof puzzelEventsGetBySource>>>
export type PuzzelPhoneNumbersGetAllResult = NonNullable<Awaited<ReturnType<typeof puzzelPhoneNumbersGetAll>>>
export type PuzzelPhoneNumbersCreateResult = NonNullable<Awaited<ReturnType<typeof puzzelPhoneNumbersCreate>>>
export type PuzzelPhoneNumbersGetByIdResult = NonNullable<Awaited<ReturnType<typeof puzzelPhoneNumbersGetById>>>
export type PuzzelPhoneNumbersUpdateResult = NonNullable<Awaited<ReturnType<typeof puzzelPhoneNumbersUpdate>>>
export type PuzzelPhoneNumbersDeleteResult = NonNullable<Awaited<ReturnType<typeof puzzelPhoneNumbersDelete>>>
export type PuzzelPhoneNumbersGetByNumberResult = NonNullable<Awaited<ReturnType<typeof puzzelPhoneNumbersGetByNumber>>>
export type PuzzelUsersGetAllResult = NonNullable<Awaited<ReturnType<typeof puzzelUsersGetAll>>>
export type PuzzelUsersCreateResult = NonNullable<Awaited<ReturnType<typeof puzzelUsersCreate>>>
export type PuzzelUsersGetByIdResult = NonNullable<Awaited<ReturnType<typeof puzzelUsersGetById>>>
export type PuzzelUsersUpdateResult = NonNullable<Awaited<ReturnType<typeof puzzelUsersUpdate>>>
export type PuzzelUsersDeleteResult = NonNullable<Awaited<ReturnType<typeof puzzelUsersDelete>>>
